import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { formatAriaProperties } from '@dojo/widgets/common/util';
import { createNlsMiddleware } from '@holmescorp/lcc-state';
import css from '../css/progress-viz.m.css';
const nls = createNlsMiddleware('ditabook');
const factory = create({ nls, theme }).properties();
export const ProgressViz = factory(({ properties, middleware: { nls, theme } }) => {
    const { messages: { assess_progress_threshold_low_label = '[ditabook] assess_progress_threshold_low_label', assess_progress_threshold_mid_label = '[ditabook] assess_progress_threshold_mid_label', assess_progress_threshold_high_label = '[ditabook] assess_progress_threshold_high_label', assess_progress_threshold_low = '60', assess_progress_threshold_high = '80', assess_not_applicable_label = 'Not Applicable', assess_not_applicable_topics = '' } } = nls();
    const { xqa, title, percent, topic } = properties();
    const score = percent * 100;
    const themeCss = theme.classes(css);
    const naTopics = assess_not_applicable_topics.split(',').map((t) => t.trim());
    let statusClass = '';
    let iconClass = '';
    let statusLabel = '';
    if (score === 0 || score < parseFloat(assess_progress_threshold_low)) {
        statusClass = themeCss.inexperienced;
        iconClass = 'fas fa-exclamation-triangle';
        statusLabel = assess_progress_threshold_low_label;
    }
    else if (score < parseFloat(assess_progress_threshold_high)) {
        statusClass = themeCss.improvement;
        iconClass = 'fas fas fa-exclamation-circle';
        statusLabel = assess_progress_threshold_mid_label;
    }
    else {
        statusClass = themeCss.proficient;
        iconClass = 'fas fa-check-circle';
        statusLabel = assess_progress_threshold_high_label;
    }
    return naTopics.includes(topic)
        ? v('div', { key: 'root', xqa, classes: [themeCss.progressItem, themeCss.notApplicable] }, [
            v('div', { classes: [themeCss.icon] }),
            v('div', { classes: [themeCss.sectionLabel] }, [
                v('div', { classes: [themeCss.sectionTitle], role: 'heading', ...formatAriaProperties({ level: '3' }) }, [title]),
                v('div', { classes: [themeCss.sectionStatusLabel] }, [assess_not_applicable_label])
            ])
        ])
        : v('div', { key: 'root', xqa, classes: [themeCss.progressItem] }, [
            v('i', { classes: [iconClass, themeCss.icon, statusClass] }),
            v('div', { classes: [themeCss.sectionLabel] }, [
                v('div', { classes: [themeCss.sectionTitle], role: 'heading', ...formatAriaProperties({ level: '3' }) }, [title]),
                v('div', { classes: [themeCss.sectionStatusLabel] }, [statusLabel])
            ])
        ]);
});
